export class EksClusterSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryPointArn",
            "baseName": "recoveryPointArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsBackupVaultName",
            "baseName": "awsBackupVaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterArn",
            "baseName": "clusterArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "kubernetesVersion",
            "baseName": "kubernetesVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "childRecoveryPointCount",
            "baseName": "childRecoveryPointCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "failedChildJobCount",
            "baseName": "failedChildJobCount",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return EksClusterSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
